import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import app from "./app";

const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});

export default db;
